// advancement status Enum
export const advancementStatusEnum = Object.freeze({
  // Fetch SalesRoutes
  EVENT_FETCH_SALESROUTES_REQUEST: 'EVENT_FETCH_SALESROUTES_REQUEST',
  EVENT_FETCH_SALESROUTES_SUCCESS: 'EVENT_FETCH_SALESROUTES_SUCCESS',
  EVENT_FETCH_SALESROUTES_FAIL: 'EVENT_FETCH_SALESROUTES_FAIL',
  // Fetch SalesRoute
  EVENT_FETCH_SALESROUTE_REQUEST: 'EVENT_FETCH_SALESROUTE_REQUEST',
  EVENT_FETCH_SALESROUTE_SUCCESS: 'EVENT_FETCH_SALESROUTE_SUCCESS',
  EVENT_FETCH_SALESROUTE_FAIL: 'EVENT_FETCH_SALESROUTE_FAIL',
  // Patch
  EVENT_PATCH_SALESROUTE_REQUEST: 'EVENT_PATCH_SALESROUTE_REQUEST',
  EVENT_PATCH_SALESROUTE_SUCCESS: 'EVENT_PATCH_SALESROUTE_SUCCESS',
  EVENT_PATCH_SALESROUTE_FAIL: 'EVENT_PATCH_SALESROUTE_FAIL',
  // Reset form
  EVENT_RESET_FORM_SALESROUTE_REQUEST: 'EVENT_RESET_FORM_SALESROUTE_REQUEST',
  EVENT_RESET_FORM_SALESROUTE_SUCCESS: 'EVENT_RESET_FORM_SALESROUTE_SUCCESS',
  // Describe
  EVENT_DESCRIBE_SALESROUTE_REQUEST: 'EVENT_DESCRIBE_SALESROUTE_REQUEST',
  EVENT_DESCRIBE_SALESROUTE_SUCCESS: 'EVENT_DESCRIBE_SALESROUTE_SUCCESS',
  EVENT_DESCRIBE_SALESROUTE_FAIL: 'EVENT_DESCRIBE_SALESROUTE_FAIL',
  // Loans
  EVENT_LOANS_BLOCK_REQUEST: 'EVENT_LOANS_BLOCK_REQUEST',
  EVENT_LOANS_BLOCK_SUCCESS: 'EVENT_LOANS_BLOCK_SUCCESS',
  EVENT_LOANS_BLOCK_FAIL: 'EVENT_LOANS_BLOCK_FAIL',
  // ExtraData Contract
  EVENT_EXTRADATA_BLOCK_REQUEST: 'EVENT_EXTRADATA_BLOCK_REQUEST',
  EVENT_EXTRADATA_BLOCK_SUCCESS: 'EVENT_EXTRADATA_BLOCK_SUCCESS',
  EVENT_EXTRADATA_BLOCK_FAIL: 'EVENT_EXTRADATA_BLOCK_FAIL',
  // GeneralData
  EVENT_GENERALDATA_BLOCK_REQUEST: 'EVENT_GENERALDATA_BLOCK_REQUEST',
  EVENT_GENERALDATA_BLOCK_SUCCESS: 'EVENT_GENERALDATA_BLOCK_SUCCESS',
  EVENT_GENERALDATA_BLOCK_FAIL: 'EVENT_GENERALDATA_BLOCK_FAIL',
  // Print
  EVENT_PRINT_SALESROUTE_REQUEST: 'EVENT_PRINT_SALESROUTE_REQUEST',
  EVENT_PRINT_SALESROUTE_SUCCESS: 'EVENT_PRINT_SALESROUTE_SUCCESS',
  EVENT_PRINT_SALESROUTE_FAIL: 'EVENT_PRINT_SALESROUTE_FAIL',
  // Offers
  EVENT_OFFERS_BLOCK_REQUEST: 'EVENT_OFFERS_BLOCK_REQUEST',
  EVENT_OFFERS_BLOCK_SUCCESS: 'EVENT_OFFERS_BLOCK_SUCCESS',
  EVENT_OFFERS_BLOCK_FAIL: 'EVENT_OFFERS_BLOCK_FAIL',
  // Subscription
  EVENT_SUBSCRIPTION_BLOCK_REQUEST: 'EVENT_SUBSCRIPTION_BLOCK_REQUEST',
  EVENT_SUBSCRIPTION_BLOCK_SUCCESS: 'EVENT_SUBSCRIPTION_BLOCK_SUCCESS',
  EVENT_SUBSCRIPTION_BLOCK_FAIL: 'EVENT_SUBSCRIPTION_BLOCK_FAIL',
  // Finalize
  EVENT_FINALIZE_SALESROUTE_REQUEST: 'EVENT_FINALIZE_SALESROUTE_REQUEST',
  EVENT_FINALIZE_SALESROUTE_SUCCESS: 'EVENT_FINALIZE_SALESROUTE_SUCCESS',
  EVENT_FINALIZE_SALESROUTE_FAIL: 'EVENT_FINALIZE_SALESROUTE_FAIL',
  // Closed
  EVENT_CLOSED_REQUEST: 'EVENT_CLOSED_REQUEST',
  EVENT_CLOSED_SUCCESS: 'EVENT_CLOSED_SUCCESS',
  EVENT_CLOSED_FAIL: 'EVENT_CLOSED_FAIL',
  // On hold
  EVENT_ONHOLD_REQUEST: 'EVENT_ONHOLD_REQUEST',
  EVENT_ONHOLD_SUCCESS: 'EVENT_ONHOLD_SUCCESS',
  EVENT_ONHOLD_FAIL: 'EVENT_ONHOLD_FAIL',
});

export const statusSalesRouteEnum = Object.freeze({
  CLOSED: 'CLOSED',
  COMPUTED: 'COMPUTED',
  CREATED: 'CREATED',
  PRESUBSCRIBED: 'PRESUBSCRIBED',
  PRESIMULATED: 'PRESIMULATED',
  LOANSDESCRIBED: 'LOANSDESCRIBED',
  COVEREDDESCRIBED: 'COVEREDDESCRIBED',
  EXTRADATADESCRIBED: 'EXTRADATADESCRIBED',
  GENERALDATADESCRIBED: 'GENERALDATADESCRIBED',
  PRINTED: 'PRINTED',
  ONHOLD: 'ONHOLD',
  SIMULATED: 'SIMULATED',
  SUBSCRIBED: 'SUBSCRIBED',
  INPROGRESS: 'INPROGRESS',
  // PUT-ON-HOLD
  PUTONHOLD_QUESTIONNAIRE: 'PUTONHOLD_QUESTIONNAIRE',
  PUTONHOLD_QUOTATION: 'PUTONHOLD_QUOTATION',
  PUTONHOLD_OFFERS: 'PUTONHOLD_OFFERS',
});
